<p-card class="p-card container">
  <h3 i18n>FAQ</h3>

  <p-panel
    i18n-header
    header="À qui dois-je parler si j’ai des questions?"
    [toggler]="'header'"
    [collapsed]="true"
    [toggleable]="true">
    <p i18n
      >Vous pouvez contacter un de nos agents en téléphonant au
      <a href="tel:14388067227:">+1 (438) 806-7227</a>
      ou en écrivant à l'adresse courriel
      <a href="mailto:support@emma.ca" class="underline">support&#64;emma.ca </a>
    </p>
  </p-panel>

  <p-panel
    i18n-header
    header="Est-ce que mon client peut payer par carte de crédit?"
    [toggler]="'header'"
    [collapsed]="true"
    [toggleable]="true"
    ><p i18n
      >Les clients peuvent payer par compte bancaire (DPA) ou encore par carte de crédit. Vous pourrez
      sélectionner l’option choisie dans la proposition du client.</p
    >
    <p i18n
      >Concernant la carte de crédit, prendre note qu’il s’agit bien
      <strong>des paiements mensuels</strong> et non seulement de la première prime.</p
    >
  </p-panel>

  <p-panel
    i18n-header
    header="Est-ce possible d’obtenir les polices Emma en version papier?"
    [toggler]="'header'"
    [collapsed]="true"
    [toggleable]="true"
    ><p i18n
      >Vous pourrez télécharger les polices de vos clients à partir de votre tableau de bord. Pour éviter les
      délais, complications et surtout, pour rester en contrôle de l’expérience offerte, nous vous suggérons
      <strong>d’imprimer vous-même les polices</strong> et de vous charger de la livraison.</p
    >
    <p i18n
      >Si vous n’êtes pas en mesure de le faire, vous pouvez contacter un de nos agents en téléphonant au
      <a href="tel:14388067227:">+1 (438) 806-7227</a>
      ou en écrivant à l'adresse courriel
      <a href="mailto:support@emma.ca" class="underline">support&#64;emma.ca </a>
    </p>
  </p-panel>

  <p-panel
    i18n-header
    header="Comment puis-je obtenir une illustration avec Emma?"
    [toggler]="'header'"
    [collapsed]="true"
    [toggleable]="true"
    ><p i18n
      >La plateforme Emma ne permet pas d’avoir des illustrations imprimables (PDF) pour le moment. Pour
      obtenir les primes de nos produits, vous devez compléter le questionnaire médical via l’onglet «
      proposition ».</p
    >
  </p-panel>

  <p-panel
    i18n-header
    header="Mon client a complété sa demande, mais je n’ai toujours pas reçu la police. Quoi faire?"
    [toggler]="'header'"
    [collapsed]="true"
    [toggleable]="true"
    ><p i18n
      >Généralement, la police est générée de manière instantanée. Il est possible qu’en cas de panne, de
      maintenance, ou d’erreur dans la proposition, cette dernière soit retenue en attente d’approbation avant
      d’être émise. Dans un tel cas, un délai de 24h sera requis par notre équipe afin d’éviter toute erreur à
      l’émission de la police.</p
    >
  </p-panel>

  <p-panel
    i18n-header
    header="La tarification est-elle effectuée avec l’âge exact?"
    [toggler]="'header'"
    [collapsed]="true"
    [toggleable]="true"
    ><p i18n
      >Oui, la tarification des produits Emma est effectuée selon <strong>l’âge exact</strong> des assurés,
      contrairement à l’âge le plus proche de la date d’anniversaire. C’est pourquoi il est important de
      prendre compte de la date d’anniversaire des clients lors de la proposition, puisqu’elle sera annulée si
      un changement d’âge survient avant que le client ne termine et ne confirme son achat.</p
    >
  </p-panel>

  <p-panel
    i18n-header
    header="Comment fonctionne le calcul de l’analyse du besoin d’assurance vie Emma?"
    [toggler]="'header'"
    [collapsed]="true"
    [toggleable]="true">
    <p i18n>Le calcul de l’analyse de besoin d’assurance vie Emma est le suivant :</p>
    <p i18n
      >Le solde de l’hypothèque + Les dettes +
      {{ funeralCost | currency: 'CAD' : 'symbol-narrow' : '1.0-0' }} de frais funéraires + Remplacement de
      revenu (voir plus bas) + Héritage supplémentaire désiré - Le montant d’assurance vie en vigueur - les
      économies.</p
    >
    <p i18n
      >Pour le remplacement de revenu, nous utilisons 70% du salaire net dans le cas d’un propriétaire de
      maison et 100% du salaire net dans le cas d’une personne non-propriétaire. Le nombre d’années utilisées
      dans le calcul du remplacement de revenu est égal au nombre d’années qui séparent l’âge du plus jeune
      des enfants de son 18ième anniversaire de naissance. Toutefois, dans le cas d’un couple sans enfant,
      nous utilisons 3 ans pour le calcul du remplacement de revenu, et pour une personne célibataire sans
      enfant, nous n’ajoutons pas de remplacement de revenu dans le calcul de l’analyse du besoin d’assurance
      vie.</p
    >
  </p-panel>

  <p-panel
    i18n-header
    header="Jusqu'à quel âge est-il possible de transformer une police d’assurance?"
    [toggler]="'header'"
    [collapsed]="true"
    [toggleable]="true">
    <p i18n
      >Les clients qui possèdent une T1 ou une T10 peuvent la transformer en T100 avant l’âge de 55 ans. Les
      clients qui possèdent une T20 peuvent la transformer avant l’âge de 45 ans.</p
    >
  </p-panel>

  <p-panel
    i18n-header
    header="Y a-t-il un montant de couverture minimum lors d'une transformation?"
    [toggler]="'header'"
    [collapsed]="true"
    [toggleable]="true">
    <p i18n
      >Le droit de transformation vers une T100 s'exerce pour un montant de couverture minimal de
      {{ 25000 | currency: 'CAD' : 'symbol-narrow' : '1.0-0' }}.</p
    >
  </p-panel>

  <p-panel
    i18n-header
    header="Y a-t-il un droit d'échange?"
    [toggler]="'header'"
    [collapsed]="true"
    [toggleable]="true">
    <p i18n
      >Non. Il n'est pas possible de convertir une T1 vers une T10 ou T20, ou encore une T10 vers une T20.
      Dans ce cas, une nouvelle police devra être émise (remplacement de police).</p
    >
  </p-panel>
</p-card>
